// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__5Ebbt","info":"UpdateTermsInfo_info__1lVim"};